<template>
  <div class="c-app" :class="{'c-dark-theme': $store.state.gui.darkMode}">
    <TheSidebar/>
    <CWrapper class="wrapper-custom">
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <router-view></router-view>
          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'

export default {
  name: 'TheContainer',

  components: {
    TheSidebar,
    TheHeader,
    TheFooter
  },
}
</script>

<style scoped>
/*
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
*/
</style>
